const PROJECT_KEY_NAME = "project-key";
const COMPONENTS_NAME = "components";
const FILTERS_NAME = "filter-ids";

export { COMPONENTS_NAME, FILTERS_NAME, PROJECT_KEY_NAME };
//# sourceMappingURL=index.esm.js.map
